module.exports = __webpack_public_path__ + "static/media/scene-mobile.b5435288.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/scene-mobile.png
// module id = 128
// module chunks = 0